import React,{useState,useEffect, use} from 'react';
import axios from '../../../../plugins/axios';
import Toast from '../../../../plugins/useToast';
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil';
import { demoModeState } from '../../../../plugins/recoil';

const Demo = ({handleClose}) => {
    const { t, i18n } = useTranslation()
    const [isDemoActive, setIsDemoActive] = useRecoilState(demoModeState);   

    // Demo 모드 토글 핸들러
    const handleDemoToggle = async (type) => {
        try{
            if (type === 'start') {
                const res = await axios.post('/demo/start')
                if(res.code != 200) throw res;
                localStorage.setItem('demoMode', true);
                setIsDemoActive(true);
                Toast({ isSuccess: true, msg: t(`setting.demoModeStartSuccess`) });                
            } else if (type === 'stop') {
                const res = await axios.post('/demo/end')
                if(res.code != 200) throw res;
                localStorage.setItem('demoMode', false);
                setIsDemoActive(false);
                Toast({ isSuccess: true, msg: t(`setting.demoModeStopSuccess`) });                
            } 

            const userRes = await axios.get('/user/me')
            if (userRes?.data?.language) {
                i18n.changeLanguage(userRes.data.language)
                localStorage.setItem('lang', userRes.data.language)
            }else{
                localStorage.setItem('lang', '')
            }
            
            handleClose();
        }
        catch(err){
            console.warn(err);
            Toast({ isSuccess: false, msg: t(`setting.demoModeToggleError`) });
        }
    }

    return (
        <div>
            <p className="mb-[16px] text-[18px] font-normal leading-[110%]">{t('setting.demoMode')}</p>
            <div className='flex gap-[8px]'>
                <div>
                    <button className={`w-[256px] h-[32px] py-[7px] px-[8px] rounded-[6px] font-light leading-[110%]
                            ${!isDemoActive ? ' text-white border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'
                            : 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'}
                            active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                        onClick={() => handleDemoToggle('start')}
                        disabled={isDemoActive}
                    >
                        {t('setting.start')}
                    </button>
                </div>
                <div>                    
                    <button className={`w-[256px] h-[32px] py-[7px] px-[8px] rounded-[6px] font-light leading-[110%]
                            ${isDemoActive ? ' text-white border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'
                            : 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'}
                            active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                        onClick={() => handleDemoToggle('stop')}
                        disabled={!isDemoActive}
                    >
                        {t('setting.stop')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Demo;